import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { Loader2 } from "lucide-react";

export function RequireAuth({ children }) {
  const { user, loading, hydrate } = useAuth();
  const loc = useLocation();

  useEffect(() => {
    if (!user && !loading) hydrate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center app-bg-dark" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-sky" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children || <Outlet />;
}

export default RequireAuth;
